export function getLargePageScrollContainerScrollY(target: EventTarget | null): number | null {
  if (typeof window === 'undefined' || !(target instanceof HTMLElement)) {
    return null;
  }

  const mainElement = document.querySelector('main');
  const containsMain =
    mainElement instanceof HTMLElement &&
    (target === mainElement || target.contains(mainElement));

  if (!containsMain) {
    return null;
  }

  const scrollableDistance = target.scrollHeight - target.clientHeight;
  if (scrollableDistance <= 0) {
    return null;
  }

  const overflowY = window.getComputedStyle(target).overflowY;
  const allowsVerticalScroll =
    overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
  const isViewportSized = target.clientHeight >= window.innerHeight * 0.5;

  if (!allowsVerticalScroll || !isViewportSized) {
    return null;
  }

  return target.scrollTop;
}
